// extracted by mini-css-extract-plugin
module.exports = {"text":"UsualText_text__3y2Pd"};